import { render, staticRenderFns } from "./MatterSimplifiedDestructionForm.vue?vue&type=template&id=af2ca96e&"
import script from "./MatterSimplifiedDestructionForm.vue?vue&type=script&lang=js&"
export * from "./MatterSimplifiedDestructionForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterSimplifiedDestructionForm.vue?vue&type=style&index=0&id=af2ca96e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports